import { B as ButtonIcon, d as defineCustomElement$1 } from './buttonIcon.js';
var SkpButtonIcon = ButtonIcon;
var defineCustomElement = defineCustomElement$1;
export { SkpButtonIcon, defineCustomElement };